module.exports = __webpack_public_path__ + "img/Stemness-OVCA_10X_OC.1566d719.png";